import { appState, dispatch } from "../redux/redux-config";
import { inAppNotificationApi } from "../api/in-app-notification-api";

const inAppNotifications = {
    fetchList: async () => {
        const token = appState().user.token;
        const result = await inAppNotificationApi.getList(token);
        if (result?.success) {
            dispatch("IN_APP_NOTIFICATIONS_LOADED", result.notifications);
            dispatch("IN_APP_UNREAD_COUNT", result.unreadCount);
        }
        return result;
    },

    pollUnreadCount: async () => {
        const token = appState().user.token;
        const result = await inAppNotificationApi.getUnreadCount(token);
        if (result?.success) {
            dispatch("IN_APP_UNREAD_COUNT", result.unreadCount);
        }
    },

    markRead: async (id) => {
        const token = appState().user.token;
        await inAppNotificationApi.markRead(token, id);
        dispatch("IN_APP_MARK_READ", id);
    },

    markAllRead: async () => {
        const token = appState().user.token;
        await inAppNotificationApi.markAllRead(token);
        dispatch("IN_APP_MARK_ALL_READ");
    }
};

export default inAppNotifications;

export function inAppNotificationsReducer(state = { items: [], unreadCount: 0 }, action) {
    switch (action.type) {
        case "IN_APP_NOTIFICATIONS_LOADED":
            return { ...state, items: action.payload };
        case "IN_APP_UNREAD_COUNT":
            return { ...state, unreadCount: action.payload };
        case "IN_APP_MARK_READ":
            return {
                ...state,
                items: state.items.filter(n => n.id !== action.payload),
                unreadCount: Math.max(0, state.unreadCount - 1)
            };
        case "IN_APP_MARK_ALL_READ":
            return {
                ...state,
                items: [],
                unreadCount: 0
            };
        default:
            return state;
    }
}
